import { render, staticRenderFns } from "./RentabilidadeAnual.vue?vue&type=template&id=5032d1b3&scoped=true&"
import script from "./RentabilidadeAnual.vue?vue&type=script&lang=js&"
export * from "./RentabilidadeAnual.vue?vue&type=script&lang=js&"
import style0 from "./RentabilidadeAnual.vue?vue&type=style&index=0&id=5032d1b3&scoped=true&lang=css&"
import style1 from "./RentabilidadeAnual.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5032d1b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
